module.exports = __webpack_public_path__ + "img/kjjh_thumbnail.e5c07cbd.jpg";